<template>
    <PageFull header="Адм. переводы" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <TransfersList />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import TransfersList from '@/components/admin/TransfersList.vue'
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            activeItem: 0
        }
    },
    components: {
        TransfersList,
        PageFull
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>